import z from 'zod/v4';
import { LoudnormConfigSchema, ResolutionSchema } from './miscSchemas.js';
import { SupportedErrorAudioTypes, SupportedErrorScreens, SupportedHardwareAccels, } from './settingsSchemas.js';
// These are purposefully duplicated from the DB code so that the
// exposed API can differ from the DB. This allows us to make
// incremental changes on the backend without exposing them immediately
// on the frontend.
export const SupportedVaapiDrivers = [
    'system',
    'ihd',
    'i965',
    'radeonsi',
    'nouveau',
];
export const SupportedTranscodeVideoOutputFormats = [
    'h264',
    'hevc',
    'mpeg2video',
];
export const SupportedTranscodeAudioOutputFormats = [
    'aac',
    'ac3',
    'copy',
    'mp3',
    'libopus',
    'eac3',
];
export const TranscodeConfigSchema = z.object({
    id: z.string(),
    name: z
        .string({
        error: (iss) => iss.input === undefined ? 'Name is required' : 'Invalid input',
    })
        .min(1, { error: 'Name cannot be empty' }),
    threadCount: z.coerce.number(),
    hardwareAccelerationMode: z.enum(SupportedHardwareAccels),
    vaapiDriver: z.enum(SupportedVaapiDrivers),
    vaapiDevice: z.string().nullable(),
    resolution: ResolutionSchema,
    videoFormat: z.enum(SupportedTranscodeVideoOutputFormats),
    videoProfile: z.string().nullable(),
    videoPreset: z.string().nullable(),
    videoBitDepth: z.union([z.literal(8), z.literal(10)]).nullable(),
    videoBitRate: z.coerce.number(),
    videoBufferSize: z.coerce.number(),
    audioChannels: z.coerce.number(),
    audioFormat: z.enum(SupportedTranscodeAudioOutputFormats),
    audioBitRate: z.coerce.number(),
    audioBufferSize: z.coerce.number(),
    audioSampleRate: z.coerce.number(),
    audioVolumePercent: z.coerce.number().default(100),
    audioLoudnormConfig: LoudnormConfigSchema.nullable(),
    normalizeFrameRate: z.boolean(),
    deinterlaceVideo: z.boolean(),
    disableChannelOverlay: z.boolean(),
    errorScreen: z.enum(SupportedErrorScreens),
    errorScreenAudio: z.enum(SupportedErrorAudioTypes),
    isDefault: z.boolean(),
    disableHardwareDecoder: z.boolean().default(false),
    disableHardwareEncoding: z.boolean().default(false),
    disableHardwareFilters: z.boolean().default(false),
});
//# sourceMappingURL=transcodeConfigSchemas.js.map